/**
 * @export
 * @class ShareDealPopup
 * 공유특가 딜일 때 사용하는 공유하기 팝업
 */
export default class ShareDealPopup {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_shareDealPopup';
    this.elFixedShareBtn = $('.tlbarwp #_showSharePop');

    this.render();
    this.cacheElement();
    this.setEvent();
  }

  cacheElement() {
    this.welWrapper = this.welContainer.find('#_shareDealPopup');
    this.elRefreshBtn = this.welWrapper.find('.share_deal_refresh');
    this.elFaqBtn = this.welWrapper.find('.share_deal_faq_btn');
    this.elInner = this.welWrapper.find('.popup_inner');
  }

  setEvent() {
    this.elRefreshBtn.on('click', () => {
      window.location.reload();
    });
    this.elFaqBtn.on('click', () => {
      if (this.elFaqBtn.hasClass('on')) {
        this.elFaqBtn.removeClass('on');
      } else {
        this.elFaqBtn.addClass('on');
        this.elInner.scrollTop(
          this.welWrapper.find('.share_deal_faq_wrap').outerHeight(true)
        );
      }
    });
    if (this.elFixedShareBtn.length) {
      this.elFixedShareBtn.off('click');
      this.elFixedShareBtn.on('click', () => {
        this.open();
      });
    }
  }

  clearEvent() {
    this.elRefreshBtn.off('click');
    this.elFaqBtn.off('click');
    this.elFixedShareBtn.off('click');
  }

  open() {
    if (!TMON.bLogin)
      TMON.oApp.oUtil.login(window.location.href, '', true);

    // PC일 때는 Hash 사용하지 않는다.
    const layerOption = {
      welTargetLayer: $(`#${this.sWrapper}`),
      bPullToRefresh: false,
    };
    if (TMON.sDevice === 'PW') {
      layerOption.bSetHash = false;
      layerOption.bUseHistorybackOnClose = false;
      layerOption.bShowDimmed = false;
    }
    TMON.oApp.oUtil.handleOpenLayer(layerOption);
  }

  render() {
    const sHtml = `
    <section class="popup popup_share_deal ${
      TMON.bMobile ? 'popup_layer' : ''
    }" id="_shareDealPopup" style="display:none">

      <header class="popup_header">
        <h3 class="popup_header_title">공유하기</h3>
        <button type="button" class="popup_header_close" data-role="close" aria-label="팝업닫기">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
          </svg>
        </button>
      </header>

      <div class="popup_contents">
        <article class="popup_inner">
          <p class="share_deal_desc">
            이 딜은 공유하기를 완료하면 구매 가능합니다.<br>
            <span class="light">친구에게 공유하고 구매해보세요!</span>
          </p>

          <ul class="share_deal_sns_list">
            <li class="share_deal_sns_item">
              <button type="button" class="share_deal_sns_btn kakao" data-type="kakaotalk" tl:area=${
                TMON.bMobile ? 'SDMSC' : 'SDPSC'
              } tl:ord="1">
                <span class="share_deal_sns_name">카카오톡</span>
              </button>
            </li>
            <li class="share_deal_sns_item">
              <button type="button" class="share_deal_sns_btn facebook" data-type="facebook" tl:area=${
                TMON.bMobile ? 'SDMSC' : 'SDPSC'
              } tl:ord="2">
                <span class="share_deal_sns_name">페이스북</span>
              </button>
            </li>
          </ul>

          <p class="share_deal_guide">공유하기를 완료하면 <span class="thick">새로고침</span> 후 구매해주세요.</p>

          <button type="button" class="share_deal_refresh">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
              <g fill="none" fill-rule="evenodd">
                <g stroke="#F27935" stroke-width="1.2">
                  <path d="M15.243 7.904c0 4.053-3.286 7.338-7.34 7.338-4.053 0-7.338-3.285-7.338-7.338S3.85.564 7.904.564c2.831 0 5.288 1.603 6.512 3.951" transform="translate(-886 -743) translate(785 443) translate(30 30) translate(0 256) translate(72 15)"></path>
                  <path d="M14.702 0.883L14.702 4.271 11.313 4.271" transform="translate(-886 -743) translate(785 443) translate(30 30) translate(0 256) translate(72 15) rotate(9 13.008 2.577)"></path>    
                </g>
              </g>
            </svg>
            새로고침하여 구매하기
          </button>

          <button type="button" class="share_deal_faq_btn">
            <span class="share_deal_faq_title">공유를 했는데도 구매가 되지 않으시나요?</span>
          </button>
          
          <div class="share_deal_faq_wrap">
            <div class="share_deal_faq_box">
              <p>먼저, 여러 번 페이지를 새로고침 해주세요. 아래는 공유로 인정되지 않는 경우입니다.</p>
              <ul>
                <li>자기 자신에게 공유한 경우</li>
                <li>공유를 하지 않고 도중에 창을 닫은 경우</li>
                <li>제공된 플랫폼 이외에 공유를 시도한 경우</li>
                <li>비정상적인 접근으로 판단되는 경우</li>
              </ul>
            </div>
            <p class="share_deal_faq_desc">단, 공유로 인정되더라도 ${
              TMON.bMobile ? '<br>' : ''
            }수량 제한으로 구매가 제한될 수 있습니다.</p>
          </div>
        </article>
      </div>
    </section>`;

    this.welContainer.append(sHtml);
  }
}
